// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Uf-z","title":"Vf-z","cta":"Wf-z","disabled":"Xf-z"};